import { render, staticRenderFns } from "./LoadingPannel.vue?vue&type=template&id=66dc9688&"
import script from "./LoadingPannel.vue?vue&type=script&lang=ts&"
export * from "./LoadingPannel.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingPannel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports